import { Component , TemplateRef} from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { NavComponent } from "../navigation/nav.component";
import { CommonModule } from '@angular/common';
import { DashboardService } from '@services/dashboard.service';
import { Admin, AdminAccessRole } from '@interfaces/models.interface';
import { ServerResponse } from '@interfaces/general.interface';
import { LocalService } from '@services/local.service';
import { FormsModule } from '@angular/forms'; // Import FormsModule here
import {RouterModule} from '@angular/router';
import { MomentModule } from 'ngx-moment';
import { Apollo } from 'apollo-angular';
import { gql } from 'apollo-angular';
import { AuthStore } from '@store/auth.store';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { GET_ADMINS, GET_ADMINS_LEGACY } from '@gql_queries/admin/queries';
import { CREATE_ADMIN } from '@gql_queries/admin/mutations';
import { DownloadHandlerUtil } from '@shared/utils/download-handler-util';
import { ADMIN_ACCESS_ROLES, SET_ADMIN_ACCESS_ROLES } from '@gql_queries/admin/access-roles';
import { AdminPermission } from '@enums/admin-permission.enum';
import { AdminPermissionService } from '@services/admin-permission.service';
import { isUnsupportedByApi } from '@shared/utils/graphql-support.util';
import {
    isMissingPermissionError,
    MISSING_PERMISSION_MESSAGE,
} from '@shared/utils/admin-permission-error.util';
import { AdminRolesComponent } from './admin-roles/admin-roles.component';

@Component({
    selector: 'app-dashboard-admins',
    standalone: true,
    templateUrl: './dashboard-admins.component.html',
    styleUrl: './dashboard-admins.component.css',
    imports: [HeaderComponent, NavComponent, CommonModule, FormsModule, RouterModule, MomentModule, AdminRolesComponent],
})

export class DashboardAdminsComponent {
    constructor(
        private router: Router,
        private dasher: DashboardService,
        private localservice: LocalService,
        private apollo: Apollo,
        private authStore: AuthStore,
        private toastr: ToastrService,
        private modalService: NgbModal,
        private downloadHandler: DownloadHandlerUtil,
        private permissions: AdminPermissionService
    ) { }

    /** Every role, for assigning them. Empty on an API from before roles. */
    public allRoles: AdminAccessRole[] = [];
    public rolesSupported = true;
    /** Role ids ticked on the open admin's details. */
    public selectedRoleIds = new Set<string>();
    public isEditingRoles = false;
    public isSavingRoles = false;
    /** Role ids ticked in the Create Admin form. */
    public createRoleIds = new Set<string>();

    get canManageAdmins(): boolean {
        return this.permissions.can(AdminPermission.AdminsManage);
    }

    get isSuperadmin(): boolean {
        return !!this.permissions.snapshot?.isSuperadmin;
    }

    public adminList: Admin[] = [];

    public searchKeyword: string = '';
    public currentSelectedPageList: Admin[] = [];
    public maxPages: number = 0;
    public disableActionBtns: any = {
        next: false,
        prev: false,
    };
    public riderPages: number[] = [];
    public currentPage: number = 1;
    public pageSize: number = 15;

    public detailViewed: Record<string, any> = {};
    public showDetails: boolean = false;

    adminForm = {
        name: '',
        email: '',
        accessLevel: 'admin' // default value
    };

    public activeTabs: any = {
        users: true,
        roles: false
    };

    ngOnInit(): void {
        this.permissions.load().subscribe();
        this.fetchAdmins();
        this.fetchRoles();
       /*  this.dasher.tryFetchAdmins().subscribe((res: ServerResponse) => {
            if(res.status){
            res.body.forEach((consumer_instance : any) => {
                let i = consumer_instance;
                this.adminList.push(i);
            });

            this.maxPages = this.localservice.getTotalPages(this.adminList, this.pageSize);
            this.riderPages = Array.from({ length: this.maxPages}, (_, i) => i + 1);
            this.currentSelectedPageList = this.localservice.paginateData(this.adminList, this.currentPage, this.pageSize)
            
            if(this.maxPages == 1){
                this.disableActionBtns.next = true;
                this.disableActionBtns.prev = true;
            }else{
                this.disableActionBtns.next = false;
                this.disableActionBtns.prev = true;
            }//end if
            }//end fn
        }); */
    }

    downloadAdminsReport(): void {
        this.downloadHandler.downloadReport('admins', {
            data: this.currentSelectedPageList,
            fileName: 'admins-report',
        });
    }

    /* setPageSelected(setPage: number){
        if(setPage > this.maxPages){
            this.currentPage = this.maxPages;
        }else{
            this.currentPage = setPage;
        }//end if
  
        if(this.currentPage == 1){
            this.disableActionBtns.prev = true;
        }else{
            this.disableActionBtns.prev = false;
        }//end if
  
        if(this.currentPage == this.maxPages){
            this.disableActionBtns.next = true;
        }else{
            this.disableActionBtns.next = false;
        }//end if
        
        this.currentSelectedPageList = this.localservice.paginateData(this.adminList, this.currentPage, this.pageSize)
    }//end fn */
  
    /* nextPrev(action: string){
        switch(action){
            case 'next':
                this.currentPage++
            break;
  
            case 'prev':
                this.currentPage--
            break;
        }//end swithc
  
        if(this.currentPage == 1){
            this.disableActionBtns.prev = true;
        }else{
            this.disableActionBtns.prev = false;
        }//end if
  
        if(this.currentPage == this.maxPages){
            this.disableActionBtns.next = true;
        }else{
            this.disableActionBtns.next = false;
        }//end if
  
        this.currentSelectedPageList = this.localservice.paginateData(this.adminList, this.currentPage, this.pageSize)
    }//end fn */

    nextPrev(action: string){
        /* var tabActive = '';
        Object.keys(this.couponTabs).forEach((x) => {
            if(this.couponTabs[x]){
                tabActive = x;
            }//end if
        }); */

        switch(action){
            case 'next':
                this.fetchAdmins('next');
            break;
  
            case 'prev':
                this.fetchAdmins('prev');
            break;
        }//end swithc
    }//end fn
  
  
    searchData(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.searchKeyword = inputElement.value;

        if (this.searchKeyword.trim() === '') {
            console.log('Input is empty');
            this.currentSelectedPageList = this.adminList;
        } else {
            this.currentSelectedPageList = this.adminList.filter(object => {
                // Helper function to recursively search through nested objects
                const searchInObject = (obj: any): boolean => {
                    for (const key in obj) {
                        const value = obj[key];
                        
                        // Skip if null or undefined
                        if (value == null) continue;
                        
                        // If value is an object or array, search recursively
                        if (typeof value === 'object') {
                            if (searchInObject(value)) return true;
                        }
                        // Check if the value includes the search term
                        else if (value.toString().toLowerCase().includes(this.searchKeyword.toLowerCase())) {
                            return true;
                        }
                    }
                    return false;
                };
                
                return searchInObject(object);
            });
        }
    }//end fn

    viewDetails(details: Admin){
        this.showDetails = true;
        this.detailViewed = details;
        this.isEditingRoles = false;
        this.resetSelectedRoles();
    }//end fn

    // ----- access roles -----

    fetchRoles(): void {
        this.apollo
            .query<any>({ query: ADMIN_ACCESS_ROLES, fetchPolicy: 'network-only' })
            .subscribe({
                next: (res) => {
                    this.rolesSupported = true;
                    this.allRoles = res.data?.['adminAccessRoles'] ?? [];
                },
                error: (error) => {
                    if (isUnsupportedByApi(error)) this.rolesSupported = false;
                },
            });
    }

    /** The Roles tab changed the roles; keep this page's copies in step. */
    onRolesChanged(roles: AdminAccessRole[]): void {
        this.allRoles = roles;
    }

    isSuperadminAccount(admin: Record<string, any> | Admin): boolean {
        return admin?.['accessLevel'] === 'superadmin';
    }

    roleNames(admin: Admin): string {
        if (this.isSuperadminAccount(admin)) return 'Superadmin — every permission';
        const roles = admin.accessRoles ?? [];
        return roles.length ? roles.map((role) => role.name).join(', ') : 'No roles — no access';
    }

    /** Null when the open admin's roles can be changed here; otherwise why not. */
    get roleEditBlocker(): string | null {
        if (!this.canManageAdmins) return 'You need the Admins and Roles — Manage permission to change roles.';
        if (this.isSuperadminAccount(this.detailViewed)) return 'A superadmin holds every permission; roles do not apply.';
        return null;
    }

    private resetSelectedRoles(): void {
        const roles: AdminAccessRole[] = this.detailViewed['accessRoles'] ?? [];
        this.selectedRoleIds = new Set(roles.map((role) => role.roleId));
    }

    toggleRole(target: Set<string>, roleId: string, checked: boolean): void {
        if (checked) target.add(roleId);
        else target.delete(roleId);
    }

    startEditRoles(): void {
        this.resetSelectedRoles();
        this.isEditingRoles = true;
    }

    cancelEditRoles(): void {
        this.resetSelectedRoles();
        this.isEditingRoles = false;
    }

    saveAdminRoles(): void {
        const adminId = this.detailViewed['adminId'];
        if (!adminId) return;

        this.isSavingRoles = true;
        this.apollo
            .mutate<any>({
                mutation: SET_ADMIN_ACCESS_ROLES,
                variables: { adminId, roleIds: [...this.selectedRoleIds] },
            })
            .subscribe({
                next: ({ data }) => {
                    this.isSavingRoles = false;
                    const roles: AdminAccessRole[] = data?.['setAdminAccessRoles'] ?? [];
                    this.detailViewed = { ...this.detailViewed, accessRoles: roles };
                    this.adminList = this.adminList.map((admin) =>
                        admin.adminId === adminId ? { ...admin, accessRoles: roles } : admin
                    );
                    this.currentSelectedPageList = this.adminList;
                    this.resetSelectedRoles();
                    this.isEditingRoles = false;
                    this.toastr.success('Roles updated. They apply immediately.');
                    this.fetchRoles();
                },
                error: (error) => {
                    this.isSavingRoles = false;
                    this.reportError(error, "Error updating the admin's roles");
                },
            });
    }

    private reportError(error: any, fallback: string): void {
        if (isMissingPermissionError(error)) {
            this.toastr.error(MISSING_PERMISSION_MESSAGE);
            return;
        }
        if (error?.message === 'Unauthorized') return; // the error link signs out
        this.toastr.error(error?.message || fallback);
    }

    returnToList(){
        this.showDetails = false;
        this.detailViewed = {};

        this.currentPage = 1;
        this.currentSelectedPageList = this.adminList;
    }//end fn

    fetchAdmins(action: string = '', searchQuery: string = '') {
        var fromPage = 1;

        if(action != '') {
            fromPage = this.currentPage;
            switch(action) {
                case 'next':
                    this.currentPage++
                    break;
                case 'prev':
                    if(this.currentPage != 1) {
                        this.currentPage--
                    }
                    break;
            }
        }

        const query = this.rolesSupported ? GET_ADMINS : GET_ADMINS_LEGACY;

        this.apollo
            .watchQuery({
                fetchPolicy: 'network-only',
                query,
                variables: {
                    page: this.currentPage,
                    querySearch: searchQuery
                }
            }).valueChanges.subscribe({
                // Apollo Client 4 delivers a failed watchQuery as a result with
                // `error` set, not through the error callback — handle both.
                next: (res: any) => {
                    if (res.error) {
                        this.onAdminsError(res.error, query, fromPage, action, searchQuery);
                        return;
                    }
                    if (res.data && res.data['admins'] && res.data['admins'].length !== 0) {
                        this.adminList = res.data['admins'];
                        this.currentSelectedPageList = this.adminList;
                    } else if (!res.loading) {
                        this.currentPage = fromPage;
                    }
                },
                error: (error) => this.onAdminsError(error, query, fromPage, action, searchQuery)
            });
    }

    private onAdminsError(error: any, query: unknown, fromPage: number, action: string, searchQuery: string): void {
        // An API from before admin roles: list admins without them. Keyed on
        // the query that ran, not the flag — the roles query may have failed
        // first and flipped it already.
        if (query === GET_ADMINS && isUnsupportedByApi(error)) {
            this.rolesSupported = false;
            this.currentPage = fromPage;
            this.fetchAdmins(action, searchQuery);
            return;
        }
        this.currentPage = fromPage;
        this.reportError(error, 'Error loading admins');
    }

    showCreateAdminModal(modal: TemplateRef<any>){
        this.adminForm = { name: '', email: '', accessLevel: 'admin' };
        this.createRoleIds = new Set();
        this.modalService.open(modal,{ size: 'lg',  backdrop: 'static', keyboard: false });
    }

    createAdminData() {
        if (!this.adminForm.name || !this.adminForm.email || !this.adminForm.accessLevel) {
            this.toastr.error('Please fill in all required fields');
            return;
        }

        const input = {
            name: this.adminForm.name,
            email: this.adminForm.email,
            accessLevel: this.adminForm.accessLevel
        };
        // A superadmin needs no roles; anyone else has no access without one.
        const roleIds = this.adminForm.accessLevel === 'superadmin' ? [] : [...this.createRoleIds];

        this.apollo.mutate({
            mutation: CREATE_ADMIN,
            variables: {
                createAdminInput: input
            }
        }).subscribe({
            next: ({ data }: any) => {
                const created = data?.['createAdmin'];
                this.modalService.dismissAll();
                this.adminForm = { name: '', email: '', accessLevel: 'admin' }; // Reset form
                this.createRoleIds = new Set();

                if (created?.adminId && roleIds.length) {
                    this.assignRolesToNewAdmin(created.adminId, roleIds);
                } else {
                    this.toastr.success('Admin created successfully');
                    this.fetchAdmins(); // Refresh the list
                }
            },
            error: (error) => {
                this.reportError(error, 'Error creating admin');
            }
        });
    }

    /**
     * Roles are a second call — createAdmin predates them. If it fails the
     * account still exists, so say so plainly rather than "creation failed".
     */
    private assignRolesToNewAdmin(adminId: string, roleIds: string[]): void {
        this.apollo
            .mutate<any>({ mutation: SET_ADMIN_ACCESS_ROLES, variables: { adminId, roleIds } })
            .subscribe({
                next: () => {
                    this.toastr.success('Admin created with their roles');
                    this.fetchAdmins();
                    this.fetchRoles();
                },
                error: (error) => {
                    this.toastr.warning(
                        `Admin created, but their roles were not assigned: ${error?.message || 'unknown error'}. Assign them from the admin's details.`
                    );
                    this.fetchAdmins();
                },
            });
    }

    tabCallFunction(tabIndex: string){
        Object.keys(this.activeTabs).forEach((x) => {
            this.activeTabs[x] = false;
        });
    
        this.activeTabs[tabIndex] = true;
        this.fetchAdmins(tabIndex);
      }//end fn
}
